import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Avatar } from '@mui/material';
import { useFirestore } from 'react-redux-firebase';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SecurityIcon from '@mui/icons-material/Security';

const ImpersonationBanner = () => {
    const firestore = useFirestore();
    const surrogateId = sessionStorage.getItem('surrogate_uid');
    const [surrogateUser, setSurrogateUser] = useState(null);

    useEffect(() => {
        if (surrogateId) {
            firestore.collection('users').doc(surrogateId).get().then(doc => {
                if (doc.exists) {
                    setSurrogateUser({ id: doc.id, ...doc.data() });
                }
            });
        }
    }, [surrogateId, firestore]);

    if (!surrogateId) return null;

    const stopImpersonating = () => {
        sessionStorage.removeItem('surrogate_uid');
        sessionStorage.removeItem('surrogate_profile');
        window.location.href = '/learningLogs'; // Go back to admin list
    };

    return (
        <Box
            sx={{
                bgcolor: '#ef4444',
                color: 'white',
                py: 1,
                px: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                boxShadow: '0 -2px 10px rgba(0,0,0,0.2)'
            }}
        >
            <Box display="flex" alignItems="center" gap={2}>
                <SecurityIcon fontSize="small" />
                <Typography variant="body2" fontWeight={800} sx={{ letterSpacing: 1 }}>
                    DEBUG MODE: IMPERSONATING USER
                </Typography>
                {surrogateUser && (
                    <Box display="flex" alignItems="center" gap={1} ml={2} sx={{ bgcolor: 'rgba(0,0,0,0.2)', px: 1.5, py: 0.5, borderRadius: 5 }}>
                        <Avatar src={surrogateUser.avatarUrl || surrogateUser.photoUrl} sx={{ width: 20, height: 20 }} />
                        <Typography variant="caption" fontWeight={700}>
                            {surrogateUser.firstname} {surrogateUser.lastname} ({surrogateUser.email})
                        </Typography>
                    </Box>
                )}
            </Box>
            <Button
                variant="contained"
                size="small"
                onClick={stopImpersonating}
                startIcon={<ExitToAppIcon />}
                sx={{
                    bgcolor: 'white',
                    color: '#ef4444',
                    fontWeight: 800,
                    '&:hover': { bgcolor: '#f8fafc' }
                }}
            >
                Stop Impersonating
            </Button>
        </Box>
    );
};

export default ImpersonationBanner;
